import { Cidade } from "../types/cidade";

export const novaCidade = (): Cidade => {
  return {
    nome: "",
    uf: "",
  };
};
